/* ═══════════════════════════════════════════════════════════════════════════
   flats-mobile-filter.js — короткий фильтр комнатности на телефоне, порядок
   блоков над выдачей и чистка шторки на витрине ОДНОГО дома. Префикс ztf-.
   Пара к /css/flats-mobile-filter.css (запись в public/flats.php).

   Перенос черновика tools/.hero-draft/zadacha-tel-filtr.js (20-21.08.2026).

   ⛔ УЗЕЛ ПЕРЕНОСИМ, А НЕ КОПИРУЕМ. flats.js вешает обработчик на сам
      #roomsBtns (делегатом) и потом ищет кнопки по '#roomsBtns .room-btn'.
      Копия получила бы тот же id — два узла с одним id, и подсветка выбранного
      разошлась бы с выдачей. Перенос сохраняет и обработчик, и связь.

   ⛔ ПЕРЕСТАНОВКА СЛУШАЕТ СМЕНУ РАЗМЕРА, А НЕ РЕШАЕТ ОДИН РАЗ ПРИ ЗАГРУЗКЕ.
      Черновики этого проекта уже наступали на это: скрипт решал «телефон или
      компьютер» при запуске, и после поворота экрана половина вида была не та.
      Порог 900 пересекается поворотом крупного телефона (405×928 → 928×405).
      matchMedia со слушателем возвращает узел на место в ОБЕ стороны.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  if (window.__broniFlatsMobileFilter) return;

  const rooms = document.getElementById('roomsBtns');
  if (!rooms) return;

  const home = rooms.parentElement;            // где он лежит на компьютере
  if (!home) return;

  const section = document.querySelector('.flats-filters-section');
  if (!section) return;

  window.__broniFlatsMobileFilter = true;

  // Гнездо для телефонной строки: своё, чтобы не зависеть от чужой раскладки.
  // ⛔ НЕ <section>: у main.css правило `section { padding: 100px 0 }`, и один
  //    неверный тег дал бы 177 px пустоты между фильтром и выдачей.
  const nest = document.createElement('div');
  nest.className = 'ztf-rooms';

  // Ставим гнездо перед секцией фильтра — то есть сразу над выдачей. Планка
  // «Расширенный фильтр» (.zkv-mstrip) может появиться позже, поэтому
  // цепляемся за саму секцию: она в разметке с самого начала.
  const strip0 = document.querySelector('.zkv-mstrip');
  if (strip0 && strip0.parentElement) {
    strip0.insertAdjacentElement('afterend', nest);
  } else {
    section.insertAdjacentElement('beforebegin', nest);
  }

  const toolbar = document.querySelector('.flats-toolbar-section');

  /* ── Порядок блоков ───────────────────────────────────────────────────────
     Владелец 20.08: «Дешевле · Дороже · Больше · Новые, Свод · Плитка · Список
     · Планы — вот это всё поставь после фильтра студия-1-2-3-4, а сам
     расширенный фильтр поставь последним».
     Логика та же, что у человека в голове: сначала грубо отсечь по комнатам,
     потом выбрать порядок и вид показа, и только если этого не хватило —
     лезть в расширенный набор. Планка расширенного фильтра шла первой и
     предлагала подробную настройку раньше, чем человек посмотрел выдачу.
     ⛔ Переставляем на ЛЮБОЙ ширине, а не под медиа-обёрткой. Гнездо на
     компьютере пусто и схлопнуто (`:empty`), планка там `display:none` —
     видимых последствий у перестановки нет ни одного, и это ПРОВЕРЕНО
     замером против варианта без блока. А вот перестановка «только на
     телефоне» означала бы разный порядок узлов до и после поворота экрана:
     то есть ещё одну одностороннюю дверь.                                   */
  const orderBlocks = () => {
    if (!toolbar || !toolbar.parentElement) return;
    // Гнездо комнатности — перед строкой сортировки и видов.
    if (nest.nextElementSibling !== toolbar) {
      toolbar.insertAdjacentElement('beforebegin', nest);
    }
    // Планка расширенного фильтра — после неё.
    const strip = document.querySelector('.zkv-mstrip');
    if (strip && strip.previousElementSibling !== toolbar) {
      toolbar.insertAdjacentElement('afterend', strip);
    }
  };

  /* ── Подпись планки ───────────────────────────────────────────────────────
     ⛔ ЧУЖОЙ УЗЕЛ НЕ ПЕРЕПИСЫВАЕМ. `refreshLabels()` соседнего блока пишет в
     `.zkv-mstrip__txt` при КАЖДОЙ смене фильтра. Черновик отвечал на это
     сторожем-наблюдателем: два писателя в один узел, толкающиеся на каждый
     клик, — приём, который в этом проекте уже разъезжался. Своя подпись в
     СВОЁМ узле снимает спор целиком: чужой узел живёт и получает свои записи,
     просто скрыт стилем, а показывается наш. У каждого узла ровно один
     писатель, наблюдателя нет вовсе.                                        */
  const LABEL = 'Расширенный фильтр';
  const relabel = () => {
    const strip = document.querySelector('.zkv-mstrip');
    const btn = strip && strip.querySelector('.zkv-mstrip__btn');
    const theirs = strip && strip.querySelector('.zkv-mstrip__txt');
    if (!strip || !btn || !theirs) return false;
    if (strip.classList.contains('ztf-relabel')) return true;
    const mine = document.createElement('span');
    mine.className = 'ztf-mlabel';
    mine.textContent = LABEL;
    theirs.insertAdjacentElement('afterend', mine);
    strip.classList.add('ztf-relabel');
    return true;
  };

  const mq = window.matchMedia('(max-width: 900px)');

  // Группа, в которой кнопки лежат на компьютере: у неё есть своя подпись
  // «Комнатность». Уехали кнопки — подпись осталась висеть в шторке одна, без
  // содержимого. Прячем группу вместе с переносом и возвращаем вместе с ним же.
  const homeGroup = home.closest('.flats-filter-group');

  const place = () => {
    if (mq.matches) {
      if (rooms.parentElement !== nest) nest.appendChild(rooms);
      if (homeGroup) homeGroup.classList.add('ztf-off');
    } else {
      if (rooms.parentElement !== home) home.appendChild(rooms);
      if (homeGroup) homeGroup.classList.remove('ztf-off');
    }
  };

  place();
  orderBlocks();
  if (!relabel()) {
    // Планку строит соседний блок витрины — она может появиться позже нас.
    // ⛔ СЛУШАЕМ УЗКО. Планка встаёт рядом с секцией фильтра, а не где попало;
    //    наблюдатель за всем документом дёргался бы на 65 карточек выдачи
    //    подряд без всякой пользы. Сторож обязан смотреть туда, что стережёт.
    const zone = section.parentNode || document.body;
    const wait = new MutationObserver(() => {
      orderBlocks();
      if (relabel()) wait.disconnect();
    });
    wait.observe(zone, { childList: true, subtree: true });
    window.setTimeout(() => wait.disconnect(), 15000);
  }
  if (mq.addEventListener) {
    mq.addEventListener('change', place);
  } else if (mq.addListener) {
    mq.addListener(place);                     // старые браузеры
  }

  // Шторку могли открыть/закрыть — узел от этого не переезжает, и подсветка
  // выбранного остаётся единственной. Синхронизации двух списков здесь НЕТ,
  // потому что список один: узел ПЕРЕНЕСЁН, а не скопирован.

  /* ── Витрина одного дома: город и ЖК из шторки убираем ────────────────────
     ⛔ ПРИЗНАК ОДИН — СЕРВЕРНАЯ ПЕРЕМЕННАЯ. Черновик ждал класса `zvh-on` от
     соседнего блока рендеров: во-первых, в переносе тот класс называется
     `zvh-jk`, во-вторых — и это важнее — сосед ставит его ТОЛЬКО когда нашёл
     шапку страницы, то есть «дом» и «класс» это два разных признака, которые
     разойдутся в первый же день. `BRONI_FLATS_BUILDING_ID` печатает сервер, он
     есть с первой строки разметки, и им же flats.js держит дом при сбросе
     фильтра. Один признак — один смысл.                                     */
  const buildingId = window.BRONI_FLATS_BUILDING_ID;

  const hideKnown = () => {
    if (!buildingId) return true;              // городская витрина — прятать нечего
    // ⛔ ПАНЕЛЬ ИЩЕМ КАЖДЫЙ РАЗ, А НЕ ОДИН ПРИ ЗАПУСКЕ. Класс `.zkv-panel`
    //    вешает соседний блок, и на момент старта этого файла его может ещё не
    //    быть: захваченный в переменную `null` навсегда оставлял бы проверку
    //    ложной — код при этом выглядел бы правильным, а поля не прятались.
    const box = document.querySelector('.zkv-panel');
    if (!box) return false;
    let hit = 0;
    box.querySelectorAll('.flats-filter-group').forEach((g) => {
      const isCity = !!g.querySelector('#flatsCityFilter, [data-city-modal-open]');
      const isJk = !!g.querySelector('project-picker, #filterBuilding');
      if (isCity || isJk) { g.classList.add('ztf-off'); hit++; }
    });
    return hit > 0;
  };

  /* ── Сброс фильтра на витрине дома: дом держит САМ flats.js ─────────────
     ⛔ ЗДЕСЬ ЖИЛ «ВОЗВРАТ ДОМА ПОСЛЕ СБРОСА», И ОН НЕ РАБОТАЛ. Слушатель ловил
     клик по «Сбросить» и через 0 и 900 мс слал `project-change` с домом
     страницы. Но loadFlats() в flats.js молча выходит, пока идёт прошлая
     загрузка, а прошлой была загрузка САМОГО сброса — без building_id. Итог
     на проде 25.09 («ЖК РИДЗ»): один запрос списка на весь город, «Найдено
     14 449» под заголовком ЖК, а возврат дёргал только фасеты фильтра.
     Вдобавок это был второй писатель одного состояния: его `project-change`
     обнулял корпус, и корпус, выбранный на генплане в первые 900 мс после
     сброса, молча пропадал.
     С 25.09 resetFilters() сам оставляет дом страницы (PINNED_BUILDING), и
     писатель у дома один. Возврата здесь нет и заводить его снова не нужно:
     проба — tests/JS/flats-reset-keeps-jk.test.js.                          */

  if (!hideKnown()) {
    const zone2 = section.parentNode || document.body;
    const watch = new MutationObserver(() => {
      if (hideKnown()) watch.disconnect();     // сделали — больше не слушаем
    });
    watch.observe(zone2, { childList: true, subtree: true });
    // Подстраховка: если панель не соберётся вовсе, снимаем наблюдателя, чтобы
    // он не висел на странице до конца её жизни.
    window.setTimeout(() => watch.disconnect(), 15000);
  }
})();
